import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import BasicUserLink, {
  type BasicUserLinkProps,
} from '../_partials/BasicUserLink';
import BasicUserName, { Props as BasicUsernameProps } from '../BasicUserName';

export interface Props
  extends Pick<
      BasicUsernameProps,
      'user' | 'usernameClassName' | 'showSymbol' | 'symbolClassName'
    >,
    BasicUserLinkProps {}

export const UserLink: React.FC<React.PropsWithChildren<Props>> = ({
  user,
  showSymbol,
  symbolClassName,
  usernameClassName,
  className,
  children,
  ...rest
}) => {
  const isMobile = useContext(MobileContext);

  // in some cases this could be null, example deviation.author
  if (!user) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="UserLink">
      <BasicUserLink user={user} className={className} {...rest}>
        {children ? (
          children
        ) : (
          <BasicUserName
            user={user}
            showSymbol={showSymbol}
            symbolOpensPopup={!isMobile}
            symbolClassName={symbolClassName}
            usernameClassName={usernameClassName}
          />
        )}
      </BasicUserLink>
    </ErrorBoundary>
  );
};
UserLink.displayName = 'UserLink';

export default UserLink;
